export default __webpack_public_path__ + "8b5fb9bea75c0b4d5305a16aec18e8b9.png";